import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-006feeea")

_pushScopeId("data-v-006feeea")
const _hoisted_1 = { class: "cardList flex flex-column flex-warp" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_caseCardVue = _resolveComponent("caseCardVue")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataList, (v, k) => {
      return (_openBlock(), _createBlock("div", {
        class: "card",
        key: v.uuid,
        onClick: ($event: any) => (_ctx.handleClick(v))
      }, [
        _createVNode(_component_caseCardVue, {
          class: ["pointer", _ctx.layout(k)],
          layout: _ctx.layout(k),
          "card-data": v
        }, {
          foot: _withId(({ record }) => [
            _renderSlot(_ctx.$slots, "foot", { record: record })
          ]),
          _: 2
        }, 1032, ["layout", "class", "card-data"])
      ], 8, ["onClick"]))
    }), 128))
  ]))
})